"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["href"];
const _hoisted_2 = ["src", "alt"];
const _hoisted_3 = ["href"];
const _hoisted_4 = { class: "text-[2rem] font-black uppercase leading-squished tracking-tight mb-5" };
const _hoisted_5 = { class: "flex items-center justify-start hover:underline" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "font-semibold" }, "Read Article", -1);
const SvgSprite_vue_1 = __importDefault(require("@/vendor/enso/components/SvgSprite.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'BlogPostPreview',
    props: {
        post: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("article", null, [
                (__props.post.thumbnail)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                        key: 0,
                        href: __props.post.url,
                        class: "block mb-5"
                    }, [
                        (0, vue_2.createElementVNode)("img", {
                            src: __props.post.thumbnail.urls.size_3_2_360,
                            alt: __props.post.thumbnail.alt_text,
                            class: "w-full"
                        }, null, 8, _hoisted_2)
                    ], 8, _hoisted_1))
                    : (0, vue_2.createCommentVNode)("", true),
                (0, vue_2.createElementVNode)("a", {
                    href: __props.post.url
                }, [
                    (0, vue_2.createElementVNode)("h3", _hoisted_4, (0, vue_2.toDisplayString)(__props.post.title), 1),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                            href: "icon-chevron-right",
                            class: "w-2 h-[14px] mr-3"
                        }),
                        _hoisted_6
                    ])
                ], 8, _hoisted_3)
            ]));
        };
    }
});
